// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__25Dsq","left":"Footer_left__2POAH","right":"Footer_right__EJiZv","langButton":"Footer_langButton__5xEJ8"};